import * as React from 'react';
import useDebounce from '../../../academyProgramDetail/hooks/students/useDebounce';

type UseFilterProps<T> = {
  service: any;
  initialData: T[];
  queryKey: string;
  debounceDelay?: number;
  params: string;
  parasValue: number | string;
  skip: boolean;
  limit?: number;
  extraQuery?: Record<string, unknown>;
};

export default function useFilterProgramStudent<T>({
  service,
  initialData,
  queryKey,
  debounceDelay = 300,
  params,
  parasValue,
  skip,
  limit = 10000,
  extraQuery,
}: UseFilterProps<T>) {
  const [data, setData] = React.useState<T[]>(initialData);
  const [query, setQuery] = React.useState<string>('');
  const [filteredData, setFilteredData] = React.useState<T[]>(initialData);
  const debouncedQuery = useDebounce(query, debounceDelay);

  React.useEffect(() => {
    // Cargar data inicial
    setFilteredData(initialData);
  }, [initialData]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!debouncedQuery) {
        setData(initialData);
        return;
      }

      try {
        const queryObj: Record<string, unknown> = {
          [params]: parasValue,
          $limit: limit,
          [queryKey]: debouncedQuery,
          ...extraQuery,
        };

        if (skip) {
          queryObj.skipJoin = true;
        }

        const response = await service.find({ query: queryObj });
        setData(response?.data || []);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchData();
  }, [debouncedQuery, initialData, queryKey, service, params, parasValue, skip, limit, extraQuery]);

  React.useEffect(() => {
    setFilteredData(debouncedQuery ? data : initialData);
  }, [data, debouncedQuery, initialData]);

  return {
    query,
    setQuery,
    filteredData
  };
}
